import * as blocks from '../../content';

export default class Content {
    constructor() {
        this.container = document.querySelector('#content')
    }

    load(slug) {
        const html = blocks[slug];
        this.container.innerHTML = html;
    }
}





// WEBPACK FOOTER //
// ./assets/js/Content.js